import { render } from "./GoodsListCate3.vue?vue&type=template&id=aec592e4"
import script from "./GoodsListCate3.vue?vue&type=script&lang=js"
export * from "./GoodsListCate3.vue?vue&type=script&lang=js"

import "./GoodsListCate3.vue?vue&type=style&index=0&id=aec592e4&lang=scss"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__